/**
 * Construct and render image previews.
 *
 * @module preview.image
 */

'use strict';

var dom = require('spa-dom'),
    tag = dom.tag;


/**
 * Render image/photo preview with given properties.
 *
 * @param {ScrollArea} textArea - place to show preview
 * @param {string} uri - resource uri
 * @param {Object} item - particular image data
 */
module.exports = function ( textArea, uri, item ) {
    var $image = new Image();

    $image.onload = function () {
        textArea.$body.innerHTML = '';
        textArea.$body.appendChild(dom.fragment.apply(
            null,
            [
                tag('div', {className: 'imagePreviewContainer'}, this),
                tag('div', {className: 'title'}, gettext('Name') + ':'),
                tag('div', {}, item.name),
                // eslint-disable-next-line
                item.item.Creator ? tag('div', {className: 'title'}, gettext('Creator') + ':') : tag('div', {className: 'title'}, gettext('Date') + ':'),
                item.item.Creator ? tag('div', {}, item.item.Creator) : tag('div', {}, new Date(item.item.last_modified).toLocaleDateString()),
                tag('div', {className: 'title'}, gettext('Resolution') + ':'),
                tag('div', {}, this.width + 'x' + this.height),
                tag('div', {className: 'title'}, gettext('Size') + ':'),
                tag('div', {}, require('./utils/eval.space')(item.item.size).singleObject)
            ]
        ));

        textArea.show();
        textArea.init();
    };

    $image.onerror = function ( event ) {
        console.log('error when loading image for preview');
        console.log(event);
    };

    $image.src = uri;
};
